export const API_APP_USER_PORTAL_ROUTE: string = 'rpc/portal/app-user';
export const API_APP_USER_ROLE_MAPPING_ROUTE: string =
  'rpc/dms/app-user-role-mapping';
export const API_DISTRICT_ROUTE: string = 'rpc/mdm/district';
export const API_FIELD_ROUTE: string = 'rpc/dms/field';
export const API_IMAGE_ROUTE: string = 'rpc/dms/image';
export const API_MENU_ROUTE: string = 'rpc/portal/menu';
export const API_ORGANIZATION_ROUTE: string = 'rpc/portal/organization';
export const API_PAGE_ROUTE: string = 'rpc/dms/page';
export const API_PERMISSION_ROUTE: string = 'rpc/portal/permission';
export const API_PERMISSION_FIELD_MAPPING_ROUTE: string =
  'rpc/dms/permission-field-mapping';
export const API_PERMISSION_PAGE_MAPPING_ROUTE: string =
  'rpc/dms/permission-page-mapping';
export const API_PRODUCT_ROUTE: string = 'rpc/dms/product';
export const API_PRODUCT_GROUPING_ROUTE: string = 'rpc/dms/product-grouping';
export const API_PRODUCT_IMAGE_MAPPING_ROUTE: string =
  'rpc/dms/product-image-mapping';
export const API_PRODUCT_PRODUCT_GROUPING_MAPPING_ROUTE: string =
  'rpc/dms/product-product-grouping-mapping';
export const API_PRODUCT_TYPE_ROUTE: string = 'rpc/dms/product-type';
export const API_PROVINCE_ROUTE: string = 'rpc/mdm/province';
export const API_ROLE_ROUTE: string = 'rpc/portal/role';
export const API_STORE_ROUTE: string = 'rpc/dms/store';
export const API_STORE_GROUPING_ROUTE: string = 'rpc/dms/store-grouping';
export const API_STORE_IMAGE_MAPPING_ROUTE: string =
  'rpc/dms/store-image-mapping';
export const API_STORE_TYPE_ROUTE: string = 'rpc/dms/store-type';
export const API_SUPPLIER_ROUTE: string = 'rpc/dms/supplier';
export const API_TAX_TYPE_ROUTE: string = 'rpc/dms/tax-type';
export const API_UNIT_OF_MEASURE_ROUTE: string = 'rpc/dms/unit-of-measure';
export const API_UNIT_OF_MEASURE_GROUPING_CONTENT_ROUTE: string =
  'rpc/dms/unit-of-measure-grouping-content';
export const API_UNIT_OF_MEASURE_GROUPING_ROUTE: string =
  'rpc/dms/unit-of-measure-grouping';
export const API_VARIATION_ROUTE: string = 'rpc/dms/variation';
export const API_VARIATION_GROUPING_ROUTE: string =
  'rpc/dms/variation-grouping';
export const API_WARD_ROUTE: string = 'rpc/mdm/ward';
export const API_WAREHOUSE_ROUTE: string = 'rpc/dms/warehouse';
export const API_PORTAL_ROUTE: string = 'rpc/portal';
export const API_INDIRECT_SALES_ORDER_ROUTE: string =
  'rpc/dms/indirect-sales-order';
export const API_E_ROUTE_CHANGE_REQUEST_ROUTE: string =
  'rpc/dms/e-route-change-request';

export const API_POSITION_ROUTE: string = 'rpc/mdm/position';
export const API_PROFILE_ROUTE: string = 'rpc/portal/profile';
export const API_USER_NOTIFICATION_ROUTE: string =
  'rpc/utils/user-notification';

export const API_SIGNALR_ROUTE: string = '/rpc/utils/signalr';

export const API_SITE_ROUTE: string = 'rpc/portal/site';
export const API_LICENSE_INFORMATION_ROUTE: string = 'rpc/portal/license-information';
export const API_LDAP_CONFIGURATION_ROUTE = 'rpc/portal/ldap-configuration';
export const API_LOGIN_CONFIGURATION_ROUTE = 'rpc/portal/login-configuration';
export const API_AUTHENTICATION_ROUTE = 'rpc/portal/authentication';
export const API_FILE_TEMPLATE_ROUTE = 'rpc/portal/file-template';
export const API_MENU_REPORT_ROUTE = 'rpc/portal/menu-report';
